import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-100">
            分类浏览
          </h3>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.filter(c => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-800/50 hover:bg-background-700/50 border border-background-700/30 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-700 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-foreground-400 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-300 group-hover:text-primary-400 transition-colors whitespace-nowrap">{cat.name}</span>
              <span className="text-[10px] text-foreground-500">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}